"use strict";
/**
 * AUTOGENERATED
 *
 * DO NOT MODIFY
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AU = void 0;
exports.AU = {
    numericCode: '036',
    alpha2Code: 'AU',
    alpha3Code: 'AUS',
    englishName: {
        short: 'Australia',
        full: 'Australia',
    },
    names: {
        full: {
            en: 'Australia',
            fr: "Australie (l')",
        },
        short: {
            en: 'Australia',
            fr: "Australie (l')",
        },
    },
    languages: [
        {
            languageAlpha2Code: 'en',
            languageAlpha3Code: 'eng',
            isAdministrative: true,
        },
        {
            languageAlpha2Code: 'fr',
            languageAlpha3Code: 'fra',
            isAdministrative: false,
        },
    ],
    subdivisions: {
        'AU-ACT': {
            numericCode: '036',
            code: 'AU-ACT',
            category: {
                id: '324',
                names: {
                    en: {
                        singular: 'territory',
                        plural: 'territories',
                    },
                    fr: {
                        singular: 'territoire',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Australian Capital Territory',
            },
        },
        'AU-NT': {
            numericCode: '036',
            code: 'AU-NT',
            category: {
                id: '324',
                names: {
                    en: {
                        singular: 'territory',
                        plural: 'territories',
                    },
                    fr: {
                        singular: 'territoire',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Northern Territory',
            },
        },
        'AU-NSW': {
            numericCode: '036',
            code: 'AU-NSW',
            category: {
                id: '393',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'New South Wales',
            },
        },
        'AU-QLD': {
            numericCode: '036',
            code: 'AU-QLD',
            category: {
                id: '393',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Queensland',
            },
        },
        'AU-SA': {
            numericCode: '036',
            code: 'AU-SA',
            category: {
                id: '393',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'South Australia',
            },
        },
        'AU-TAS': {
            numericCode: '036',
            code: 'AU-TAS',
            category: {
                id: '393',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Tasmania',
            },
        },
        'AU-VIC': {
            numericCode: '036',
            code: 'AU-VIC',
            category: {
                id: '393',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Victoria',
            },
        },
        'AU-WA': {
            numericCode: '036',
            code: 'AU-WA',
            category: {
                id: '393',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Western Australia',
            },
        },
    },
    cities: [
        {
            name: 'Whyalla',
            subdivision: 'South Australia',
        },
        {
            name: 'Rockingham',
            subdivision: 'Western Australia',
        },
        {
            name: 'Prospect',
            subdivision: 'South Australia',
        },
        {
            name: 'Port Hedland',
            subdivision: 'Western Australia',
        },
        {
            name: 'Perth',
            subdivision: 'Western Australia',
        },
        {
            name: 'Murray Bridge',
            subdivision: 'South Australia',
        },
        {
            name: 'Mount Isa',
            subdivision: 'Queensland',
        },
        {
            name: 'Morphett Vale',
            subdivision: 'South Australia',
        },
        {
            name: 'Mandurah',
            subdivision: 'Western Australia',
        },
        {
            name: 'Kwinana',
            subdivision: 'Western Australia',
        },
        {
            name: 'Kalgoorlie',
            subdivision: 'Western Australia',
        },
        {
            name: 'Gosnells',
            subdivision: 'Western Australia',
        },
        {
            name: 'Geraldton',
            subdivision: 'Western Australia',
        },
        {
            name: 'Gawler',
            subdivision: 'South Australia',
        },
        {
            name: 'Fremantle',
            subdivision: 'Western Australia',
        },
        {
            name: 'Darwin',
            subdivision: 'Northern Territory',
        },
        {
            name: 'Busselton',
            subdivision: 'Western Australia',
        },
        {
            name: 'Bunbury',
            subdivision: 'Western Australia',
        },
        {
            name: 'Armadale',
            subdivision: 'Western Australia',
        },
        {
            name: 'Alice Springs',
            subdivision: 'Northern Territory',
        },
        {
            name: 'Albany',
            subdivision: 'Western Australia',
        },
        {
            name: 'Adelaide',
            subdivision: 'South Australia',
        },
        {
            name: 'Woodridge',
            subdivision: 'Queensland',
        },
        {
            name: 'Wodonga',
            subdivision: 'Victoria',
        },
        {
            name: 'Werribee',
            subdivision: 'Victoria',
        },
        {
            name: 'Warrnambool',
            subdivision: 'Victoria',
        },
        {
            name: 'Wantirna South',
            subdivision: 'Victoria',
        },
        {
            name: 'Wangaratta',
            subdivision: 'Victoria',
        },
        {
            name: 'Wagga Wagga',
            subdivision: 'New South Wales',
        },
        {
            name: 'Traralgon',
            subdivision: 'Victoria',
        },
        {
            name: 'Townsville',
            subdivision: 'Queensland',
        },
        {
            name: 'Toowoomba',
            subdivision: 'Queensland',
        },
        {
            name: 'Thornbury',
            subdivision: 'Victoria',
        },
        {
            name: 'Thomastown',
            subdivision: 'Victoria',
        },
        {
            name: 'Tarneit',
            subdivision: 'Victoria',
        },
        {
            name: 'Taree',
            subdivision: 'New South Wales',
        },
        {
            name: 'Tamworth',
            subdivision: 'New South Wales',
        },
        {
            name: 'Sydney',
            subdivision: 'New South Wales',
        },
        {
            name: 'Surfers Paradise',
            subdivision: 'Queensland',
        },
        {
            name: 'Sunnybank',
            subdivision: 'Queensland',
        },
        {
            name: 'Sunbury',
            subdivision: 'Victoria',
        },
        {
            name: 'Port Stephens',
            subdivision: 'New South Wales',
        },
        {
            name: 'Springvale',
            subdivision: 'Victoria',
        },
        {
            name: 'Southport',
            subdivision: 'Queensland',
        },
        {
            name: 'South Grafton',
            subdivision: 'New South Wales',
        },
        {
            name: 'Shepparton',
            subdivision: 'Victoria',
        },
        {
            name: 'Seaford',
            subdivision: 'Victoria',
        },
        {
            name: 'Saint Kilda',
            subdivision: 'Victoria',
        },
        {
            name: 'Saint Albans',
            subdivision: 'Victoria',
        },
        {
            name: 'Rowville',
            subdivision: 'Victoria',
        },
        {
            name: 'Rockhampton',
            subdivision: 'Queensland',
        },
        {
            name: 'Richmond',
            subdivision: 'Victoria',
        },
        {
            name: 'Reservoir',
            subdivision: 'Victoria',
        },
        {
            name: 'Queanbeyan',
            subdivision: 'New South Wales',
        },
        {
            name: 'Quakers Hill',
            subdivision: 'New South Wales',
        },
        {
            name: 'Preston',
            subdivision: 'Victoria',
        },
        {
            name: 'Port Macquarie',
            subdivision: 'New South Wales',
        },
        {
            name: 'Point Cook',
            subdivision: 'Victoria',
        },
        {
            name: 'Pakenham South',
            subdivision: 'Victoria',
        },
        {
            name: 'Orange',
            subdivision: 'New South Wales',
        },
        {
            name: 'Nowra',
            subdivision: 'New South Wales',
        },
        {
            name: 'Northcote',
            subdivision: 'Victoria',
        },
        {
            name: 'Noble Park',
            subdivision: 'Victoria',
        },
        {
            name: 'Newcastle',
            subdivision: 'New South Wales',
        },
        {
            name: 'Nerang',
            subdivision: 'Queensland',
        },
        {
            name: 'Narre Warren',
            subdivision: 'Victoria',
        },
        {
            name: 'Narangba',
            subdivision: 'Queensland',
        },
        {
            name: 'Mulgrave',
            subdivision: 'Victoria',
        },
        {
            name: 'Mount Martha',
            subdivision: 'Victoria',
        },
        {
            name: 'Mount Gambier',
            subdivision: 'South Australia',
        },
        {
            name: 'Mount Eliza',
            subdivision: 'Victoria',
        },
        {
            name: 'Mosman',
            subdivision: 'New South Wales',
        },
        {
            name: 'Mornington',
            subdivision: 'Victoria',
        },
        {
            name: 'Morayfield',
            subdivision: 'Queensland',
        },
        {
            name: 'Moe',
            subdivision: 'Victoria',
        },
        {
            name: 'Mill Park',
            subdivision: 'Victoria',
        },
        {
            name: 'Mildura',
            subdivision: 'Victoria',
        },
        {
            name: 'Melton',
            subdivision: 'Victoria',
        },
        {
            name: 'Melbourne',
            subdivision: 'Victoria',
        },
        {
            name: 'Maryborough',
            subdivision: 'Queensland',
        },
        {
            name: 'Marrickville',
            subdivision: 'New South Wales',
        },
        {
            name: 'Maroubra',
            subdivision: 'New South Wales',
        },
        {
            name: 'Maitland',
            subdivision: 'New South Wales',
        },
        {
            name: 'Mackay',
            subdivision: 'Queensland',
        },
        {
            name: 'Liverpool',
            subdivision: 'New South Wales',
        },
        {
            name: 'Lismore',
            subdivision: 'New South Wales',
        },
        {
            name: 'Lilydale',
            subdivision: 'Victoria',
        },
        {
            name: 'Launceston',
            subdivision: 'Tasmania',
        },
        {
            name: 'Lara',
            subdivision: 'Victoria',
        },
        {
            name: 'Langwarrin',
            subdivision: 'Victoria',
        },
        {
            name: 'Lalor',
            subdivision: 'Victoria',
        },
        {
            name: 'Keysborough',
            subdivision: 'Victoria',
        },
        {
            name: 'Kew',
            subdivision: 'Victoria',
        },
        {
            name: 'Katoomba',
            subdivision: 'New South Wales',
        },
        {
            name: 'Hornsby',
            subdivision: 'New South Wales',
        },
        {
            name: 'Hobart',
            subdivision: 'Tasmania',
        },
        {
            name: 'Hawthorn South',
            subdivision: 'Victoria',
        },
        {
            name: 'Hampton Park',
            subdivision: 'Victoria',
        },
        {
            name: 'Griffith',
            subdivision: 'New South Wales',
        },
        {
            name: 'Greensborough',
            subdivision: 'Victoria',
        },
        {
            name: 'Granville',
            subdivision: 'New South Wales',
        },
        {
            name: 'Goulburn',
            subdivision: 'New South Wales',
        },
        {
            name: 'Gold Coast',
            subdivision: 'Queensland',
        },
        {
            name: 'Glenroy',
            subdivision: 'Victoria',
        },
        {
            name: 'Glenferrie',
            subdivision: 'Victoria',
        },
        {
            name: 'Gladstone',
            subdivision: 'Queensland',
        },
        {
            name: 'Geelong',
            subdivision: 'Victoria',
        },
        {
            name: 'Frankston East',
            subdivision: 'Victoria',
        },
        {
            name: 'Frankston',
            subdivision: 'Victoria',
        },
        {
            name: 'Forster',
            subdivision: 'New South Wales',
        },
        {
            name: 'Essendon',
            subdivision: 'Victoria',
        },
        {
            name: 'Epping',
            subdivision: 'Victoria',
        },
        {
            name: 'Epping',
            subdivision: 'New South Wales',
        },
        {
            name: 'Engadine',
            subdivision: 'New South Wales',
        },
        {
            name: 'Eltham',
            subdivision: 'Victoria',
        },
        {
            name: 'Echuca',
            subdivision: 'Victoria',
        },
        {
            name: 'Earlwood',
            subdivision: 'New South Wales',
        },
        {
            name: 'Dubbo',
            subdivision: 'New South Wales',
        },
        {
            name: 'Doncaster East',
            subdivision: 'Victoria',
        },
        {
            name: 'Doncaster',
            subdivision: 'Victoria',
        },
        {
            name: 'Devonport',
            subdivision: 'Tasmania',
        },
        {
            name: 'Deer Park',
            subdivision: 'Victoria',
        },
        {
            name: 'Deception Bay',
            subdivision: 'Queensland',
        },
        {
            name: 'Dandenong',
            subdivision: 'Victoria',
        },
        {
            name: 'Cronulla',
            subdivision: 'New South Wales',
        },
        {
            name: 'Cranbourne',
            subdivision: 'Victoria',
        },
        {
            name: 'Cranbourne',
            subdivision: 'Victoria',
        },
        {
            name: 'Craigieburn',
            subdivision: 'Victoria',
        },
        {
            name: 'Coffs Harbour',
            subdivision: 'New South Wales',
        },
        {
            name: 'Coburg',
            subdivision: 'Victoria',
        },
        {
            name: 'Clayton',
            subdivision: 'Victoria',
        },
        {
            name: 'Wollongong',
            subdivision: 'New South Wales',
        },
        {
            name: 'Cessnock',
            subdivision: 'New South Wales',
        },
        {
            name: 'Castle Hill',
            subdivision: 'New South Wales',
        },
        {
            name: 'Carrum Downs',
            subdivision: 'Victoria',
        },
        {
            name: 'Carnegie',
            subdivision: 'Victoria',
        },
        {
            name: 'Carlingford',
            subdivision: 'New South Wales',
        },
        {
            name: 'Caringbah',
            subdivision: 'New South Wales',
        },
        {
            name: 'Canberra',
            subdivision: 'Australian Capital Territory',
        },
        {
            name: 'Camberwell',
            subdivision: 'Victoria',
        },
        {
            name: 'Caloundra',
            subdivision: 'Queensland',
        },
        {
            name: 'Cairns',
            subdivision: 'Queensland',
        },
        {
            name: 'Caboolture',
            subdivision: 'Queensland',
        },
        {
            name: 'Burnie',
            subdivision: 'Tasmania',
        },
        {
            name: 'Bundaberg',
            subdivision: 'Queensland',
        },
        {
            name: 'Buderim',
            subdivision: 'Queensland',
        },
        {
            name: 'Brunswick',
            subdivision: 'Victoria',
        },
        {
            name: 'Broken Hill',
            subdivision: 'New South Wales',
        },
        {
            name: 'Brisbane',
            subdivision: 'Queensland',
        },
        {
            name: 'Boronia',
            subdivision: 'Victoria',
        },
        {
            name: 'Blacktown',
            subdivision: 'New South Wales',
        },
        {
            name: 'Berwick',
            subdivision: 'Victoria',
        },
        {
            name: 'Bendigo',
            subdivision: 'Victoria',
        },
        {
            name: 'Baulkham Hills',
            subdivision: 'New South Wales',
        },
        {
            name: 'Bathurst',
            subdivision: 'New South Wales',
        },
        {
            name: 'Banora Point',
            subdivision: 'New South Wales',
        },
        {
            name: 'Bankstown',
            subdivision: 'New South Wales',
        },
        {
            name: 'Ballarat',
            subdivision: 'Victoria',
        },
        {
            name: 'Auburn',
            subdivision: 'New South Wales',
        },
        {
            name: 'Ashfield',
            subdivision: 'New South Wales',
        },
        {
            name: 'Armidale',
            subdivision: 'New South Wales',
        },
        {
            name: 'Albury',
            subdivision: 'New South Wales',
        },
        {
            name: 'South Brisbane',
            subdivision: 'Queensland',
        },
        {
            name: 'Cheltenham',
            subdivision: 'Victoria',
        },
        {
            name: 'Randwick',
            subdivision: 'New South Wales',
        },
        {
            name: 'Dee Why',
            subdivision: 'New South Wales',
        },
        {
            name: 'Umina',
            subdivision: 'New South Wales',
        },
        {
            name: 'Palmerston',
            subdivision: 'Northern Territory',
        },
        {
            name: 'Bracken Ridge',
            subdivision: 'Queensland',
        },
        {
            name: 'North Ryde',
            subdivision: 'New South Wales',
        },
        {
            name: 'Hoppers Crossing',
            subdivision: 'Victoria',
        },
        {
            name: 'Logan City',
            subdivision: 'Queensland',
        },
        {
            name: 'Carindale',
            subdivision: 'Queensland',
        },
        {
            name: 'Paramatta',
            subdivision: 'New South Wales',
        },
        {
            name: 'Ferntree Gully',
            subdivision: 'Victoria',
        },
        {
            name: 'City of Parramatta',
            subdivision: 'New South Wales',
        },
        {
            name: 'Adelaide Hills',
            subdivision: 'South Australia',
        },
        {
            name: 'Canning Vale',
            subdivision: 'Western Australia',
        },
        {
            name: 'Glenmore Park',
            subdivision: 'New South Wales',
        },
        {
            name: 'Glen Iris',
            subdivision: 'Victoria',
        },
        {
            name: 'Balwyn North',
            subdivision: 'Victoria',
        },
        {
            name: 'Carnegie',
            subdivision: 'Victoria',
        },
        {
            name: 'Malvern East',
            subdivision: 'Victoria',
        },
        {
            name: 'Brighton East',
            subdivision: 'Victoria',
        },
        {
            name: 'Booval',
            subdivision: 'Queensland',
        },
        {
            name: 'St Albans',
            subdivision: 'Victoria',
        },
        {
            name: 'Endeavour Hills',
            subdivision: 'Victoria',
        },
        {
            name: 'Clayton',
            subdivision: 'Victoria',
        },
        {
            name: 'Taylors Lakes',
            subdivision: 'Victoria',
        },
        {
            name: 'Roxburgh Park',
            subdivision: 'Victoria',
        },
        {
            name: 'Wyndham Vale',
            subdivision: 'Victoria',
        },
        {
            name: 'Willetton',
            subdivision: 'Western Australia',
        },
        {
            name: 'Thornbury',
            subdivision: 'Victoria',
        },
        {
            name: 'Thornlie',
            subdivision: 'Western Australia',
        },
        {
            name: 'Hillside',
            subdivision: 'Victoria',
        },
        {
            name: 'Bundoora',
            subdivision: 'Victoria',
        },
        {
            name: 'Forest Lake',
            subdivision: 'Queensland',
        },
        {
            name: 'Sunnybank Hills',
            subdivision: 'Queensland',
        },
        {
            name: 'Narre Warren South',
            subdivision: 'Victoria',
        },
        {
            name: 'Dandenong North',
            subdivision: 'Victoria',
        },
        {
            name: 'Frankston South',
            subdivision: 'Victoria',
        },
        {
            name: 'Sunshine West',
            subdivision: 'Victoria',
        },
        {
            name: 'Altona Meadows',
            subdivision: 'Victoria',
        },
        {
            name: 'West Pennant',
            subdivision: 'New South Wales',
        },
    ],
};
//# sourceMappingURL=data:application/json;base64,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